import { Dispatch, SetStateAction } from "react";

import { Row } from "@/components";
import { Button } from "@/components/ui/button";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_NOTIFICATION_SURFACES, MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { cn } from "@/lib/utils";
import {
  NotificationFilterState,
  NotificationInboxFilter,
  NotificationResponse,
} from "@/types";

export const NotificationInboxFilterToggle = ({
  filterState,
  isCompact = false,
  notifications,
  setFilterState,
  trackingSurface,
}: {
  filterState: NotificationFilterState;
  isCompact?: boolean;
  notifications: NotificationResponse[];
  setFilterState: Dispatch<SetStateAction<NotificationFilterState>>;
  trackingSurface: MIXPANEL_NOTIFICATION_SURFACES;
}) => {
  const handleSelectFilter = (inboxFilter: NotificationInboxFilter) => {
    mixpanelUtils.trackFilterAndSortOptionSelected(
      MIXPANEL_SCREENS.NOTIFICATIONS,
      "Inbox filter",
      inboxFilter,
      { surface: trackingSurface },
    );
    setFilterState({ ...filterState, inboxFilter });
  };

  const allCount = notifications.length;
  const unreadCount = notifications.filter(
    (notification) => notification.readAt === null,
  ).length;

  const sizeCss = isCompact
    ? "h-7 rounded-full px-2.5 text-xs font-medium"
    : "h-8 rounded-full px-3 text-sm font-medium";
  const unselectedCss = sizeCss;
  const selectedCss = cn(
    sizeCss,
    "bg-primary-100 font-semibold text-primary-900 shadow-sm hover:bg-primary-100",
  );

  return (
    <Row className="rounded-full border border-slate-200 bg-white p-0.5">
      <Button
        className={cn(
          unselectedCss,
          filterState.inboxFilter === NotificationInboxFilter.ALL &&
            selectedCss,
        )}
        onClick={() => {
          handleSelectFilter(NotificationInboxFilter.ALL);
        }}
        variant="ghost"
      >
        All {allCount}
      </Button>
      <Button
        className={cn(
          unselectedCss,
          filterState.inboxFilter === NotificationInboxFilter.UNREAD &&
            selectedCss,
        )}
        onClick={() => {
          handleSelectFilter(NotificationInboxFilter.UNREAD);
        }}
        variant="ghost"
      >
        Unread {unreadCount}
      </Button>
    </Row>
  );
};
